<template>
  <div style="display: none">
    <div class="payments">
      <div class="col-12">
        <div class="row">

          <table class="table">
            <thead>
            <tr>
              <th>Banka</th>
              <th>Method</th>
              <th>Süre</th>
              <th>Ücret</th>
              <th>Asgari</th>
              <th>Azami</th>
              <th>Para yatır</th>
              <th>Para çek</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="payment in payments" v-if="payment.is_active">
              <td class="p-0" width="300">
                <img :src="'static/assets/img/payments/'+payment.key+'.png'" width="200"/>
              </td>
              <td>
                {{ payment._name }}
              </td>
              <td width="100" class="text-right">
                {{ payment.price }}
              </td>
              <td width="100" class="text-right">
                {{ payment.price }}
              </td>
              <td width="100" class="text-right px-1">
                {{ payment.min_amount | toMoney(session.currency) }}
              </td>
              <td width="100" class="text-right px-1">
                {{ payment.max_amount | toMoney(session.currency) }}
              </td>
              <td class="p-1 text-center">
                <template v-if="payment.is_active">
                  <router-link :to="{params: {method: payment.key, withdraw: 'pay'}}">
                    <button class="btn btn-success btn-md" type="button"
                            v-on:click="$refs.modal.open()">
                      <i class="dashicons dashicons-controls-play"></i>
                      Hemen Yatır
                    </button>
                  </router-link>
                </template>
                <template v-if="!payment.is_active">
                  <button class="btn btn-outline-warning btn-md"
                          v-tooltip="t.payment_isnot_available" type="button">
                    <i class="dashicons dashicons-lock"></i>
                    Hemen Yatır
                  </button>
                </template>
              </td>
              <td class="p-1 text-center">
                <template v-if="payment.is_active">
                  <router-link :to="{params: {method: payment.key, withdraw: 'withdraw'}}">
                    <button class="btn btn-outline-success btn-md" type="button"
                            v-on:click="$refs.modal.open()">
                      <i class="dashicons dashicons-controls-play"></i>
                      İkramiye Çek
                    </button>
                  </router-link>
                </template>
                <template v-if="!payment.is_active">
                  <button class="btn btn-outline-warning btn-md"
                          v-tooltip="t.payment_isnot_available" type="button">
                    <i class="dashicons dashicons-lock"></i>
                    İkramiye Çek
                  </button>
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <sweet-modal ref="modal" width="800">
      <component :is="$route.params.method" v-bind="{ view: $route.params.withdraw }"></component>
    </sweet-modal>
  </div>
</template>

<script>
import Payment from '@/components/payments/item';
import cep_bank from '@/components/payments/gateways/cepbank';
import papara from '@/components/payments/gateways/papara';
import paykasa from '@/components/payments/gateways/paykasa';
import jeton from '@/components/payments/gateways/jeton'
import peppara from '@/components/payments/gateways/peppara'
import bank_transfer from '@/components/payments/gateways/bank_transfer'
import coin_payments from '@/components/payments/gateways/coinpayments'
import BetSlip from '@/components/sportsbook/BetSlip';

export default {
  name: 'payments',
  components: {Payment, cep_bank, papara, paykasa, jeton, peppara, bank_transfer, coin_payments, BetSlip},
  data() {
    return {
      session: window.session,
      api: window.api,
      t: this.$root.t,
      payments: null
    }
  },
  mounted() {
    this.fetchPayments();
  },
  methods: {
    fetchPayments() {
      if (!this.isLoading) {
        this.isLoading = true;
        this.$http.get(api + 'api/v1/payment/methods',
            {params: this.$route.query}).then(response => {

          this.pagination = response.body.result.pagination;
          this.payments = Object.values(response.body.result.payments);
          this.status = response.status;

          this.isLoading = false;
        }, response => {
          this.isLoading = false;
          this.status = response.status;
        })
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.payments .col-12 {
  padding: 0 !important;
}

table {
  font-size: 12px;
  margin: 0 10px;
}

.payments .table tbody tr {
  background: #fff;
  padding: 0.5rem;
}

.payments .table tbody tr:nth-child(2n+1) {
  background: #ebebeb;
}

.payments .table tbody tr td {
  border-right: 1px solid #ccc;
}

.payments .table tbody tr td img {
  width: 100px !important;
  display: flex;
  margin: 0 auto;
}

.payments .table thead {
  background: #fff;
  line-height: 30px;
}

.payments .table thead tr th {
  border: none;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  border-right: 1px solid #ccc;
  text-align: center;
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/payments.vue